import axios from "axios";
import { getErrors } from "helpers/error";
import { serverUrl } from "services/api";

export const CREATE_BULK_SOLICITATION_CONTRACT =
	"[CREATE_BULK_SOLICITATION_CONTRACT] CREATE_BULK_SOLICITATION_CONTRACT";
export const CREATE_BULK_SOLICITATION_CONTRACT_ERROR =
	"[CREATE_BULK_SOLICITATION_CONTRACT] CREATE_BULK_SOLICITATION_CONTRACT_ERROR";
export const CREATE_BULK_SOLICITATION_CONTRACT_SUCCESS =
	"[CREATE_BULK_SOLICITATION_CONTRACT] CREATE_BULK_SOLICITATION_CONTRACT_SUCCESS";

export function createBulkSolicitationContract(
	contractSolicitations,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({
			type: CREATE_BULK_SOLICITATION_CONTRACT
		});

		try {
			const { login } = getState();

			const requestData = {
				contractSolicitations
			};

			let response = await axios.post(
				`${serverUrl}/contract-solicitation/generate-contract-solicitation`,
				requestData,
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + login.token
					}
				}
			);

			if (response.status === 200) {
				dispatch({
					type: CREATE_BULK_SOLICITATION_CONTRACT_SUCCESS,
					payload: response.data
				});

				callback && callback(null, response.data);
			} else {
				const errors = getErrors(response.data);

				dispatch({
					type: CREATE_BULK_SOLICITATION_CONTRACT_ERROR,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			console.error("Erro na requisição:", error);

			const errorMessage =
				error.response?.data?.message || error.message || "Erro de conexão";

			dispatch({
				type: CREATE_BULK_SOLICITATION_CONTRACT_ERROR,
				payload: {
					error: errorMessage
				}
			});

			callback && callback({ error: errorMessage });
		}
	};
}
